import { LOAD_EXTERNAL_SUCCESS, LOAD_USERS_SUCCESS, UPDATE_USER_FIELD, 
    LOAD_USER_BY_ID, LOAD_USER_BY_ID_SUCCESS, LOAD_USERS, UPDATE_USER_SUCCESS, User, FILTER_USERS, EMPTY_USER, 
    ERROR_UPDATING_ROLE, UPDATE_ROLE, SELECT_ALL_ROLES, SELECT_NO_ROLES, SELECT_NO_ROLES_IN_GROUP, 
    SELECT_ALL_ROLES_IN_GROUP, LOAD_EXTERNAL_USER_BY_ID_SUCCESS, 
    OPTIONS_LOADED, LOADING_OPTIONS, OFFERS_LOADED, UPDATE_EXTERNAL_USER_SUCCESS } from "./types";
import axios from '../../lib/axios';
import config from '../../config/app-config.json';

import { currentStore } from '../index';

export const companyForType = {
    'Affiliate': ['ta', 'lm','tg'],
    'Vendor': ['ta','lm','tg'],
    'Client': ['lm','tg']
}

export const loadUsers = (history = null, redirect = false) => {
    return (dispatch: any) => {
        dispatch({
            type: LOAD_USERS,
            payload: []
        })
        axios.get(`${config.serviceUrl}/users`).then((response) => {
            dispatch({
                type: LOAD_USERS_SUCCESS,
                payload: response.data
            })
            // if(history !== null && redirect) {
            //     history.push(`/account/${response.data.data[0].id}`);
            // }
        })
    }
}

export const loadExternal = (history = null, redirect = false) => {
    return (dispatch: any) => {
        dispatch({
            type: LOAD_USERS,
            payload: []
        })
        axios.get(`${config.serviceUrl}/external-users`).then((response) => {
            dispatch({
                type: LOAD_EXTERNAL_SUCCESS,
                payload: response.data
            })
            // if(history !== null && redirect) {
            //     history.push(`/account/${response.data.data[0].id}`);
            // }
        })
    }
}

export const loadExternalUserById = id => {
    return (dispatch: any) => {
        dispatch({
            type: LOAD_USER_BY_ID,
            payload: null
        })
        axios.get(`${config.serviceUrl}/external-users/${id}`).then((response) => {
            dispatch({
                type: LOAD_EXTERNAL_USER_BY_ID_SUCCESS,
                payload: response.data
            })
            setTimeout(() => {
                const store = currentStore.getState()
                loadOptions(companyForType[store.users.editedUser.account_type], store.users.editedUser.account_type)(dispatch)
            })
        })
    }
}

export const updateUserField = (field, value) => {
    return {
        type: UPDATE_USER_FIELD,
        payload: { field, value }
    }
}

export const loadUserById = id => {
    return (dispatch: any) => {
        dispatch({
            type: LOAD_USER_BY_ID,
            payload: null
        })
        axios.get(`${config.serviceUrl}/users/${id}`).then((response) => {
            dispatch({
                type: LOAD_USER_BY_ID_SUCCESS,
                payload: response.data
            })
        })
    }
}

export const saveUser = (user: User, history: any) => {
    return (dispatch: any) => {
        if (user.Username) {
            axios.put(`${config.serviceUrl}/users/${user.Username}`, user).then((response) => {
                if (response.data.statusCode && response.data.statusCode === 400) {
                    alert(response.data.message)
                } else {
                    history.push(`/`);
                    history.push(`/users/${user.Username}`);
                    dispatch({
                        type: UPDATE_USER_SUCCESS,
                        payload: response
                    })
                }
            })
        } else {
            axios.post(`${config.serviceUrl}/users`, user).then((response) => {
                if (response.data.User) {
                    history.push(`/`);
                    history.push(`/user/${response.data.User.Username}`);
                    dispatch({
                        type: UPDATE_USER_SUCCESS,
                        payload: response
                    })
                } else {
                    alert(response.data.message)
                }

            })
        }
    }
}

export const saveExternalUser = (user: User, history: any) => {
    return (dispatch: any) => {
        if (user.Username) {
            axios.put(`${config.serviceUrl}/external-users/${user.Username}`, user).then((response) => {
                if (response.data.statusCode && response.data.statusCode === 400) {
                    alert(response.data.message)
                } else {
                    history.push(`/`);
                    history.push(`/external/${user.Username}`);
                    dispatch({
                        type: UPDATE_EXTERNAL_USER_SUCCESS,
                        payload: response
                    })
                }
            })
        } else {
            axios.post(`${config.serviceUrl}/external-users`, user).then((response) => {
                if (response.data.User) {
                    history.push(`/`);
                    history.push(`/external/${response.data.User.Username}`);
                    dispatch({
                        type: UPDATE_EXTERNAL_USER_SUCCESS,
                        payload: response
                    })
                } else {
                    alert(response.data.message)
                }

            })
        }
    }
}

export const filterClients = (value: any) => ({
    type: FILTER_USERS,
    payload: value
})

export const emptyUser = () => ({
    type: EMPTY_USER
})

export const addRole = (username: string, group: any, type = 'internal') => {
    return (dispatch: any) => {
        axios.put(`${config.serviceUrl}/${type === 'internal' ? 'user_groups' : 'external_user_groups'}`, {
            username: username,
            group: group.GroupName
        }).then((response) => {
            if(response.data.error){
                dispatch({
                    type: ERROR_UPDATING_ROLE,
                    payload: response.data.error
                })
            } else {
                dispatch({
                    type: UPDATE_ROLE,
                    payload: group
                })
            }
        })
    }
}

export const removeRole = (username: string, group: any, type = 'internal') => {
    return (dispatch: any) => {
        axios.delete(`${config.serviceUrl}/${type === 'internal' ? 'user_groups' : 'external_user_groups'}`, {
            data: {
                username: username,
                group: group.GroupName
            }
        }).then((response) => {

        })
        dispatch({
            type: UPDATE_ROLE,
            payload: group.GroupName
        })
    }
}

export const resetExternalRoles = (username:string, roles:any[]) => {
    return (dispatch: any) => {
        axios.delete(`${config.serviceUrl}/resetExternalRoles`, {
            data: {
                username,
                roles: roles.map(r => r.GroupName)
            }
        }).then((response) => {

            dispatch({
                type: SELECT_NO_ROLES,
                payload: ['portal_all_access']
            })
        })
    }
}

export const selectAllRoles = roles => ({
    type: SELECT_ALL_ROLES,
    payload: roles
})

export const selectNoRoles = roles => ({
    type: SELECT_NO_ROLES,
    payload: roles
})

export const selectAllRolesInGroup = (username, roles, type = 'internal') => {
    return (dispatch: any) => {
        for (let role of roles) {
            dispatch(addRole(username, role, type))
        }

    }
}


export const selectNoRolesInGroup = (username, roles, type = 'internal') => {
    return (dispatch: any) => {
        for (let role of roles) {
            dispatch(removeRole(username, role, type))
        }
        dispatch({
            type: SELECT_NO_ROLES_IN_GROUP,
            payload: roles
        })
    }
}

export const resetPassword = (email: string, type = 'internal') => {
    return (dispatch: any) => {
        axios.put(`${config.serviceUrl}/${type === 'internal' ? 'reset_password' : 'external_reset_password'}`, {
            email: email
        }).then((response) => {
            alert('New password has been sent to the user.')
        })
    }
}

export const loadOptions = (companies: string[], account_type: string) => {

    return (dispatch: any) => {
        dispatch({
            type: LOADING_OPTIONS
        })
        const response = {};
        const options = (companies || []).map(async c => {
            const { data } = await axios.get(`${config.serviceUrl}/options_by_account_type/${c}/${account_type}`)
            response[c] = data;
            return response;
        });

        Promise.all(options).then(() => {
            dispatch({
                type: OPTIONS_LOADED,
                payload: response
            })
        })

        if(account_type === 'Affiliate'){
            const offersResp = {};
            const options = (companies || []).map(async c => {
                const { data } = await axios.get(`${config.serviceUrl}/options_by_account_type/${c}/offers`)
                offersResp[c] = data;
                return offersResp;
            });
    
            Promise.all(options).then(() => {
                dispatch({
                    type: OFFERS_LOADED,
                    payload: offersResp
                })
            })
        }
    }
}